import { sidebarData } from "./sidebar-data";

export type SidebarRouteEntry = {
  title: string;
  groupTitle: string;
};

/** url (ເຊັ່ນ /app/documents) → ຊື່ເມນູ + ກຸ່ນ sidebar */
export const sidebarRouteIndex: Record<string, SidebarRouteEntry> = {};

function register(url: string, title: string, groupTitle: string) {
  if (!url.startsWith("/app")) return;
  sidebarRouteIndex[url] = { title, groupTitle };
}

for (const group of sidebarData.navGroups) {
  for (const item of group.items) {
    if ("url" in item && item.url) {
      register(item.url, item.title, group.title);
    }
    if ("items" in item && item.items) {
      for (const sub of item.items) {
        if (sub.url) {
          register(sub.url, sub.title, group.title);
        }
      }
    }
  }
}
